import { useEffect, useRef } from 'react';

function ThreeBackground() {
  const containerRef = useRef(null);

  useEffect(() => {
    let active = true;
    let retryTimer = null;
    let animId = null;
    let onMouseMove = null;
    let onResize = null;
    let renderer = null;
    let container = null;

    const init = () => {
      if (!active) return;
      if (!window.THREE || !containerRef.current) {
        retryTimer = setTimeout(init, 100);
        return;
      }

      const THREE = window.THREE;
      container = containerRef.current;

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.setSize(window.innerWidth, window.innerHeight);
      container.appendChild(renderer.domElement);

      const particlesGeometry = new THREE.BufferGeometry();
      const particlesCount = 2000;
      const posArray = new Float32Array(particlesCount * 3);

      for (let i = 0; i < particlesCount * 3; i++) {
        posArray[i] = (Math.random() - 0.5) * 12;
      }

      particlesGeometry.setAttribute('position', new THREE.BufferAttribute(posArray, 3));

      const material = new THREE.PointsMaterial({
        size: 0.015,
        color: 0x00ffcc,
        transparent: true,
        opacity: 0.6,
      });

      const particlesMesh = new THREE.Points(particlesGeometry, material);
      scene.add(particlesMesh);
      camera.position.z = 4;

      let mouseX = 0;
      let mouseY = 0;

      onMouseMove = (event) => {
        mouseX = event.clientX / window.innerWidth - 0.5;
        mouseY = event.clientY / window.innerHeight - 0.5;
      };
      document.addEventListener('mousemove', onMouseMove);

      const animate = () => {
        if (!active) return;
        animId = requestAnimationFrame(animate);
        particlesMesh.rotation.y += 0.0005;
        particlesMesh.rotation.x += 0.0002;
        particlesMesh.position.x += (mouseX * 0.5 - particlesMesh.position.x) * 0.05;
        particlesMesh.position.y += (-mouseY * 0.5 - particlesMesh.position.y) * 0.05;
        renderer.render(scene, camera);
      };
      animate();

      onResize = () => {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
      };
      window.addEventListener('resize', onResize);
    };

    init();

    return () => {
      active = false;
      if (retryTimer) clearTimeout(retryTimer);
      if (animId) cancelAnimationFrame(animId);
      if (onMouseMove) document.removeEventListener('mousemove', onMouseMove);
      if (onResize) window.removeEventListener('resize', onResize);
      if (renderer) renderer.dispose();
      if (container && renderer?.domElement && container.contains(renderer.domElement)) {
        container.removeChild(renderer.domElement);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        opacity: 0.5,
        pointerEvents: 'none',
      }}
    />
  );
}

export default ThreeBackground;
